'use client'
import React from 'react'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Link,
  Typography,
  useTheme
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTimes,
  faDownload
} from '@fortawesome/pro-regular-svg-icons'
import Button from 'src/components/era-package/forms/Button'
import Buttons from 'src/components/era-package/era/Buttons'
import AbiEntrySummaryApiUrls from 'src/apiUrls/AbiEntrySummaryApiUrls'

const ReadOnlyField = ({ label, value }) => {
  const theme = useTheme()

  return (
    <Box>
      <Typography
        fontSize='0.875rem'
        fontWeight={500}
        color={theme.palette.text.primary}
        sx={{ opacity: 0.6 }}
      >
        {label}
      </Typography>
      <Typography color={theme.palette.text.primary}>
        {value || '-'}
      </Typography>
    </Box>
  )
}

const FileDownloadField = ({ label, fileName, disId }) => {
  const theme = useTheme()

  const handleDownload = async (e) => {
    e.preventDefault()
    if (!disId) return

    try {
      const response = await fetch(
        `${AbiEntrySummaryApiUrls.DOWNLOAD_DIS_FILE}?disId=${disId}`,
        {
          method: 'GET',
          headers: {
            Authorization:
              'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
          }
        }
      )

      if (!response.ok) {
        throw new Error('Failed to download file')
      }

      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName || 'dis-file'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Error downloading DIS file:', error)
    }
  }

  return (
    <Box>
      <Typography
        fontSize='0.875rem'
        fontWeight={500}
        color={theme.palette.text.primary}
        sx={{ opacity: 0.6 }}
      >
        {label}
            </Typography>
      {fileName ? (
        <Link
          component='button'
          variant='body1'
          onClick={handleDownload}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: 'pointer',
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            '&:hover': {
              color: theme.palette.primary.dark
            }
          }}
          title={`Download ${fileName}`}
        >
          <FontAwesomeIcon icon={faDownload} width={14} />
          {fileName}
        </Link>
      ) : (
        <Typography color={theme.palette.text.secondary}>No file available</Typography>
      )}
    </Box>
  )
}

const ViewDisFileModal = ({ open, onClose, rowData }) => {
  const theme = useTheme()

    if (!rowData) return null

  const fileId = rowData.id
  const fileName = rowData.fileName

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: { maxHeight: '90vh' }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        View DIS File
        <IconButton
          aria-label='Close view DIS file modal'
          onClick={onClose}
          sx={{ color: theme.palette.grey[500] }}
          title='Close modal'
        >
          <Box
            component={FontAwesomeIcon}
            icon={faTimes}
            sx={{ width: '1em' }}
          />
        </IconButton>
      </DialogTitle>

            <DialogContent dividers>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            py: 1
          }}
        >
          <FileDownloadField
            label='File'
            fileName={fileName}
            disId={fileId}
          />
          <ReadOnlyField label='Agency' value={rowData.agency} />
          <ReadOnlyField label='Document Type' value={rowData.documentType} />
          <ReadOnlyField label='Status' value={rowData.status} />
          <ReadOnlyField label='Submit Time' value={rowData.submitTime} />
          <ReadOnlyField label='Response Time' value={rowData.responseTime} />
          <ReadOnlyField label='User ID' value={rowData.userId} />
          <ReadOnlyField label='Submission OID' value={rowData.submissionOId} />
        </Box>
      </DialogContent>

      <DialogActions sx={{ pt: 3 }}>
        <Buttons
          advance={
            <Button onClick={onClose} variant='contained' title='Close modal'>
              Close
            </Button>
          }
        />
      </DialogActions>
    </Dialog>
  )
}

export default ViewDisFileModal
